// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2WIPr","range":"MonthRangeSwitch_range__2cPEp","disabled":"MonthRangeSwitch_disabled__1QaUX"};